// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Consultation Summaries Styles */
.consultation-summaries {
  padding: 0;
  max-width: 100%;
  margin: 0;
  width: 100%;
  background: white;
}

.consultation-summaries .header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 2rem 0 2rem;
  background: white;
}

.consultation-summaries .header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 1rem 0;
}

.consultation-summaries .header p {
  font-size: 1.1rem;
  color: #6b7280;
  margin: 0;
}

/* Search Section */
.search-section {
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  padding: 2rem 2rem 1.5rem 2rem;
  background: white;
}

.search-inputs-row {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 1200px;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  color: #6b7280;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #6b7280;
}

.empty-state .empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-state h3 {
  margin: 0 0 0.5rem 0;
  color: #374151;
  font-size: 1.5rem;
}

.empty-state p {
  margin: 0;
  font-size: 1rem;
}

/* Table Styles */
.summaries-table-container {
  background: white;
  border-radius: 0;
  box-shadow: none;
  overflow: hidden;
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 0;
  padding: 0 2rem 2rem 2rem;
}

.summaries-table {
  width: 100%;
  border-collapse: collapse;
}

.summaries-table thead {
  background-color: #f9fafb;
}

.summaries-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.summaries-table td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.summaries-table tbody tr:hover {
  background-color: #f9fafb;
}

.summaries-table tbody tr:last-child td {
  border-bottom: none;
}

/* Table Cell Styles */
.client-name {
  font-weight: 600;
  color: #1f2937;
}

.client-email {
  color: #6b7280;
  font-size: 0.875rem;
}

.summary-status {
  text-align: left;
  vertical-align: middle;
  padding-left: 2rem !important;
}

.summaries-table td.summary-status {
  display: table-cell;
  vertical-align: middle;
}

/* Date Filters */
.date-filters {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

/* Type Filter Dropdown */
.type-filter-select {
  padding: 0.75rem 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;
  cursor: pointer;
  background: white;
  min-width: 160px;
}

.type-filter-select:focus {
  outline: none;
  border-color: #3b82f6;
}

.date-input {
  padding: 0.75rem 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: border-color 0.2s;
  cursor: pointer;
}

.date-input:focus {
  outline: none;
  border-color: #3b82f6;
}

/* Lead Type Badge Styles */
.lead-type-cell {
  width: 140px;
}

.lead-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid;
}

.lead-type-badge .type-icon {
  font-size: 14px;
}

.lead-type-badge .type-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.clear-date-btn {
  padding: 0.75rem 1rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.clear-date-btn:hover {
  background-color: #dc2626;
}

/* Data Submitted Column */
.data-submitted {
  text-align: left;
  vertical-align: middle;
}

.submitted-date {
  color: #374151;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.status-indicator-inline {
  margin-top: 0.5rem;
}

/* Lead Quality Column */
.lead-quality-cell {
  text-align: left;
  vertical-align: middle;
}

.lead-quality-badge-table {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.lead-quality-badge-table.strong {
  background-color: #d1fae5;
  color: #065f46;
}

.lead-quality-badge-table.moderate {
  background-color: #fef3c7;
  color: #92400e;
}

.lead-quality-badge-table.weak {
  background-color: #fee2e2;
  color: #991b1b;
}

.lead-quality-empty {
  color: #9ca3af;
  font-size: 0.875rem;
  font-style: italic;
}

.status-badge-small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  vertical-align: middle;
}

.status-badge-small.ready {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge-small.not-started {
  background-color: #f3f4f6;
  color: #6b7280;
}

.status-badge-small.processing {
  background-color: #dbeafe;
  color: #1e40af;
}

.status-badge-small.failed {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Responsive Design for Date Filters */
@media (min-width: 768px) {
  .search-inputs-row {
    flex-direction: row;
    align-items: center;
  }

  .search-input {
    flex: 1 1;
    max-width: 400px;
  }

  .date-filters {
    flex: 1 1;
    justify-content: flex-end;
  }
}

/* Latest Slider Container */
.latest-slider-container {
  background-color: #f9fafb;
  border-top: 1px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
  padding: 1.25rem 2rem;
  margin: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.slider-controls-left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1 1;
  min-width: 200px;
}

.sort-controls {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.sort-controls label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
}

.sort-select {
  padding: 0.5rem 0.75rem;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  background: white;
  color: #374151;
  cursor: pointer;
  transition: border-color 0.2s;
  min-width: 140px;
}

.sort-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.sort-order-btn {
  padding: 0.5rem 0.75rem;
  background: white;
  border: 2px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 38px;
}

.sort-order-btn:hover {
  border-color: #3b82f6;
  background: #f0f9ff;
  color: #3b82f6;
}

.sort-order-btn:active {
  transform: scale(0.95);
}

.latest-slider-container label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
  white-space: nowrap;
  min-width: fit-content;
}

.latest-slider-container input[type="range"] {
  flex: 0 0 auto;
  width: 250px;
  min-width: 200px;
  max-width: 300px;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(to right, #3b82f6 0%, #60a5fa 100%);
  outline: none;
  appearance: none;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.2);
}

.latest-slider-container input[type="range"]::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1e40af;
  cursor: pointer;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.4);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.latest-slider-container input[type="range"]::-webkit-slider-thumb:hover {
  background: #1e3a8a;
  transform: scale(1.15);
  box-shadow: 0 4px 8px rgba(30, 64, 175, 0.5);
}

.latest-slider-container input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1e40af;
  cursor: pointer;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.4);
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.latest-slider-container input[type="range"]::-moz-range-thumb:hover {
  background: #1e3a8a;
  transform: scale(1.15);
  box-shadow: 0 4px 8px rgba(30, 64, 175, 0.5);
}

.latest-slider-container input[type="range"]::-moz-range-track {
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(to right, #3b82f6 0%, #60a5fa 100%);
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.2);
}

.latest-slider-container input[type="range"]:focus {
  outline: none;
}

.latest-slider-container input[type="range"]:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.latest-slider-container input[type="range"]:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

/* Responsive adjustments for slider */
@media (max-width: 640px) {
  .latest-slider-container {
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .slider-controls-left {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .latest-slider-container label {
    margin-bottom: 0.5rem;
  }

  .latest-slider-container input[type="range"] {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }

  .sort-controls {
    width: 100%;
    justify-content: space-between;
  }

  .sort-select {
    flex: 1 1;
    min-width: auto;
  }
}

.actions {
  text-align: center;
  vertical-align: middle;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  vertical-align: middle;
}

.status-badge.ready {
  background-color: #d1fae5;
  color: #065f46;
}

.status-badge.not-started {
  background-color: #fef3c7;
  color: #92400e;
}

.status-badge.processing {
  background-color: #dbeafe;
  color: #1e40af;
}

.status-badge.failed {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Real-time status indicator */
.pulse-dot {
  margin-left: 0.5rem;
  color: #3b82f6;
  animation: pulse 1.5s ease-in-out infinite;
  font-size: 0.8rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.view-btn {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  min-width: 70px;
}

.view-btn:hover {
  background-color: #2563eb;
}

.generate-btn {
  background-color: #10b981;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  min-width: 120px;
}

.generate-btn:hover:not(:disabled) {
  background-color: #059669;
}

.generate-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.regenerate-btn {
  background-color: #f59e0b;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  min-width: 100px;
}

.regenerate-btn:hover:not(:disabled) {
  background-color: #d97706;
}

.regenerate-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.processing-text {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: visible; /* Allow tooltip to show outside modal */
}

.summary-modal {
  background: white;
  border-radius: 0.75rem;
  max-width: 800px;
  max-height: 90vh;
  width: 90%;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #374151;
}

.modal-body {
  padding: 2rem;
  max-height: 70vh;
  overflow-y: auto;
}

.client-info {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.client-info p {
  margin: 0.25rem 0;
  color: #475569;
}

.summary-content h3 {
  margin: 0 0 1rem 0;
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
}

.summary-text {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1.5rem;
  line-height: 1.6;
  color: #374151;
  font-size: 1rem;
  white-space: pre-wrap;
  min-height: 200px;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .consultation-summaries {
    padding: 1rem;
  }
  
  .consultation-summaries .header h1 {
    font-size: 2rem;
  }
  
  .summaries-table-container {
    overflow-x: auto;
  }
  
  .summaries-table {
    min-width: 600px;
  }
  
  .summaries-table th,
  .summaries-table td {
    padding: 0.75rem 0.5rem;
  }
  
  .summary-modal {
    width: 95%;
    margin: 1rem;
  }
  
  .modal-header {
    padding: 1rem 1.5rem;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 0.25rem;
  }
  
  .action-buttons .view-btn,
  .action-buttons .regenerate-btn {
    width: 100%;
    min-width: auto;
  }
}

/* Toast Notification Styles */
.toast-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  min-width: 300px;
  max-width: 500px;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  animation: slideInRight 0.3s ease-out;
}

.toast-notification.success {
  background-color: #d1fae5;
  border: 1px solid #34d399;
  color: #065f46;
}

.toast-notification.error {
  background-color: #fef2f2;
  border: 1px solid #f87171;
  color: #991b1b;
}

.toast-content {
  display: flex;
  align-items: center;
  padding: 1rem;
  gap: 0.75rem;
}

.toast-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.toast-message {
  flex: 1 1;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
}

.toast-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: inherit;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
  flex-shrink: 0;
}

.toast-close:hover {
  opacity: 1;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Mobile responsive for toast */
@media (max-width: 640px) {
  .toast-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    min-width: auto;
    max-width: none;
  }
}

/* Two-Column Modal Layout */
.modal-content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 1rem;
}

.summary-content,
.form-data-content {
  min-width: 0; /* Allow content to shrink */
  max-width: 100%;
  overflow: visible;
}

.summary-content {
  overflow: hidden;
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.summary-header h3,
.summary-content h3,
.form-data-content h3 {
  margin: 0;
  color: #1f2937;
  font-size: 1.1rem;
  font-weight: 600;
  padding-bottom: 0;
  border-bottom: none;
}

/* Form Data Display */
.form-data-display {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  padding: 1rem;
  max-height: 500px;
  overflow-y: auto;
}

.form-data-item {
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: visible;
}

.form-data-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.form-data-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.form-data-value {
  display: block;
  font-size: 0.95rem;
  color: #1e293b;
  word-break: break-word;
  width: 100%;
  box-sizing: border-box;
}

/* Structured Data Display (for IELTS, Education, Work tables) */
.structured-data-table {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 0.375rem !important;
  padding: 0.75rem !important;
  margin-top: 0.25rem !important;
  width: 100% !important;
  border-collapse: collapse !important;
  table-layout: auto !important;
  display: table !important;
  writing-mode: horizontal-tb !important;
  direction: ltr !important;
}

.structured-data-table tbody {
  width: 100% !important;
  display: table-row-group !important;
}

.structured-data-row {
  border-bottom: 1px solid #f1f5f9 !important;
  display: table-row !important;
  writing-mode: horizontal-tb !important;
  direction: ltr !important;
}

.structured-data-row:last-child {
  border-bottom: none !important;
}

/* Force all td elements to display inline text */
.structured-data-table td {
  display: table-cell !important;
  writing-mode: horizontal-tb !important;
  white-space: normal !important;
}

.structured-data-row .sub-label {
  padding: 0.5rem 0.75rem 0.5rem 0 !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  text-align: right !important;
  vertical-align: top !important;
  white-space: nowrap !important;
  width: 1% !important;
  display: table-cell !important;
  writing-mode: horizontal-tb !important;
  direction: ltr !important;
  flex-direction: row !important;
}

.structured-data-row .sub-value {
  padding: 0.5rem 0 0.5rem 0.5rem !important;
  font-size: 0.875rem !important;
  color: #1e293b !important;
  font-weight: 500 !important;
  vertical-align: top !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
  width: auto !important;
  max-width: none !important;
  display: table-cell !important;
  writing-mode: horizontal-tb !important;
  direction: ltr !important;
  flex-direction: row !important;
}

.simple-value {
  display: inline !important;
  font-size: 0.95rem;
  color: #1e293b;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal !important;
  writing-mode: horizontal-tb !important;
}

.empty-value {
  display: inline !important;
  font-size: 0.95rem;
  color: #94a3b8;
  font-style: italic;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal !important;
  writing-mode: horizontal-tb !important;
}

/* Adjust summary modal width for two columns */
.summary-modal {
  max-width: 1400px !important;
}

/* Force horizontal text display in modal */
.summary-modal .structured-data-table {
  display: table !important;
  width: 100% !important;
}

.summary-modal .structured-data-table tbody {
  display: table-row-group !important;
}

.summary-modal .structured-data-row {
  display: table-row !important;
}

.summary-modal .structured-data-row td {
  display: table-cell !important;
  white-space: normal !important;
  writing-mode: horizontal-tb !important;
}

/* Mobile responsive for two-column layout */
@media (max-width: 1024px) {
  .modal-content-grid {
    grid-template-columns: 1fr;
  }
  
  .summary-modal {
    max-width: 90% !important;
  }
}

/* Form Data Edit Mode */
.form-data-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  position: relative;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
}

.form-data-header h3 {
  margin: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.form-data-actions {
  display: flex;
  gap: 0.5rem;
}

.edit-form-data-btn,
.save-form-data-btn,
.cancel-edit-btn {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.edit-form-data-btn {
  background: #3b82f6;
  color: white;
}

.edit-form-data-btn:hover {
  background: #2563eb;
}

.save-form-data-btn {
  background: #10b981;
  color: white;
}

.save-form-data-btn:hover {
  background: #059669;
}

.save-form-data-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.cancel-edit-btn {
  background: #ef4444;
  color: white;
}

.cancel-edit-btn:hover {
  background: #dc2626;
}

.form-data-input {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #3b82f6;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  color: #1e293b;
  background: white;
  transition: border-color 0.2s;
  box-sizing: border-box;
  max-width: 100%;
}

.form-data-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Structured Data Edit Mode */
.structured-data-edit {
  background: white;
  border: 2px solid #3b82f6;
  border-radius: 0.375rem;
  padding: 0.75rem;
  margin-top: 0.25rem;
  max-width: 100%;
  overflow: hidden;
}

.structured-data-edit-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.structured-data-edit-row:last-child {
  margin-bottom: 0;
}

.sub-label-edit {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #475569;
  text-align: left;
}

.sub-field-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #1e293b;
  background: white;
  transition: all 0.2s;
  box-sizing: border-box;
}

.sub-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.sub-field-input::placeholder {
  color: #94a3b8;
  font-size: 0.8125rem;
}

/* Regenerate Prompt */
.regenerate-prompt {
  margin-top: 1.5rem;
  padding: 1rem;
  background: #fef3c7;
  border: 2px solid #fbbf24;
  border-radius: 0.5rem;
  text-align: center;
}

.regenerate-prompt p {
  margin: 0 0 0.75rem 0;
  color: #92400e;
  font-weight: 600;
  font-size: 0.95rem;
}

.regenerate-summary-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.regenerate-summary-btn:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.regenerate-summary-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

/* Custom Tooltip */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  position: absolute;
  top: 50%;
  right: calc(100% + 12px);
  transform: translateY(-50%);
  background: #1f2937;
  color: #ffffff;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  z-index: 100000;
  width: 320px;
  pointer-events: none;
  white-space: normal;
  opacity: 1;
  display: block;
}

.custom-tooltip::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  border: 10px solid transparent;
  border-left-color: #1f2937;
}

.custom-tooltip p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #ffffff;
  text-align: left;
  display: block;
}

.custom-tooltip p:first-child {
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #ffffff;
}

.custom-tooltip p:last-child {
  color: #e5e7eb;
  font-weight: 400;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Regenerate Button in Modal */
.regenerate-in-modal-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
}

.regenerate-in-modal-btn:hover {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
}

.regenerate-in-modal-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

/* Summary Loading State */
.summary-loading {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 3rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.summary-loading .loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1.5rem;
}

.summary-loading p {
  margin: 0;
  color: #374151;
  font-size: 1.1rem;
  font-weight: 600;
}

.summary-loading .loading-subtext {
  margin-top: 0.5rem;
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 400;
}

/* ========================================
   MODERN CONSULTATION SUMMARY MODAL
   ======================================== */

/* Modern Modal Container */
.modern-summary-modal {
  background: white;
  border-radius: 0.75rem;
  max-width: 1400px;
  max-height: 95vh;
  width: 98%;
  overflow: visible; /* Allow tooltip to escape */
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
}

/* Modern Header - Blue Background */
.modern-modal-header {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: white;
  padding: 1.25rem 2rem;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.header-left {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.header-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.header-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0.25rem 0;
  color: white !important;
}

.header-description {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.95) !important;
  margin: 0;
  line-height: 1.4;
}

.modern-close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 2rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  backdrop-filter: blur(10px);
  line-height: 1;
  padding: 0;
}

.modern-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

/* Header Meta Information */
.header-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.25rem;
}

.meta-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.meta-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.meta-value {
  font-size: 1rem;
  color: white !important;
  font-weight: 600;
}

/* Lead Quality Badge in Header */
.lead-quality-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.lead-quality-badge.strong {
  background: rgba(16, 185, 129, 0.3);
  border-color: rgba(16, 185, 129, 0.5);
  color: #d1fae5;
}

.lead-quality-badge.moderate {
  background: rgba(245, 158, 11, 0.3);
  border-color: rgba(245, 158, 11, 0.5);
  color: #fef3c7;
}

.lead-quality-badge.weak {
  background: rgba(239, 68, 68, 0.3);
  border-color: rgba(239, 68, 68, 0.5);
  color: #fee2e2;
}

/* Lead Score Value */
.lead-score-value {
  font-size: 1.125rem !important;
  font-weight: 700 !important;
  color: #fbbf24 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Action Bar */
.action-bar {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  padding: 0.75rem 2rem;
  border-bottom: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  min-height: 56px;
}

.action-buttons-left {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  white-space: nowrap;
  min-width: fit-content;
  overflow: hidden;
}

.action-btn.primary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.action-btn.primary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.action-btn.secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.action-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.action-btn.regenerate {
  background: rgba(255, 255, 255, 0.95);
  color: #4f46e5;
  font-weight: 700;
}

.action-btn.regenerate:hover:not(:disabled) {
  background: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-btn.regenerate:disabled {
  background: rgba(255, 255, 255, 0.5);
  color: rgba(79, 70, 229, 0.5);
  cursor: not-allowed;
  transform: none;
}

/* Modern Tabs */
.modern-tabs {
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  padding: 0 2rem;
  display: flex;
  gap: 0.5rem;
  border-bottom: none;
}

.tab-button {
  padding: 0.875rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 0.5rem 0.5rem 0 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  margin-bottom: 0;
}

.tab-button:hover {
  color: white;
  background: rgba(255, 255, 255, 0.15);
}

.tab-button.active {
  color: #1f2937;
  background: white;
  font-weight: 700;
}

/* Modern Modal Body */
.modern-modal-body {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: visible; /* Allow horizontal tooltip overflow */
  background: #f9fafb;
}

/* Split View Layout */
.modern-modal-body.split-view {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.split-panel {
  flex: 1 1 50%; /* Equal width for both panels */
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: visible; /* Allow tooltip to escape */
  min-width: 0; /* Allow panels to shrink below their content width */
  max-width: 50%; /* Ensure panels stay equal width */
  height: fit-content;
}

/* Visual divider between panels */
.left-panel {
  border-right: 2px solid #e5e7eb;
  border-radius: 0.75rem 0 0 0.75rem;
}

.right-panel {
  border-radius: 0 0.75rem 0.75rem 0;
}

.split-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 1.25rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom: 1px solid #e5e7eb;
  min-height: 56px;
  flex-shrink: 0;
  position: relative;
  z-index: 100;
  overflow: visible;
}

.split-panel .panel-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.025em;
}

.split-panel .panel-content {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.5rem;
  background: #ffffff;
  position: relative;
  max-height: 600px; /* Set max height for scrolling */
  min-height: 400px; /* Minimum height */
}

/* Custom scrollbar styling */
.split-panel .panel-content::-webkit-scrollbar {
  width: 8px;
}

.split-panel .panel-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.split-panel .panel-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.split-panel .panel-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Always show scrollbar */
.split-panel .panel-content {
  scrollbar-gutter: stable;
}

/* Make both panels have same background */
.left-panel .panel-content {
  background: #ffffff;
}

.right-panel .panel-content {
  background: #ffffff;
}

/* Edit Data Button Tooltip */
.form-data-actions {
  position: relative;
  display: flex;
  gap: 0.5rem;
}

.edit-form-data-btn,
.save-form-data-btn,
.cancel-edit-btn {
  position: relative;
}

.edit-form-data-btn::before {
  content: '💡 Click to edit source data, then regenerate summary to update AI analysis';
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  transform: translateY(10px);
  background: linear-gradient(135deg, #3b82f6 0%, #667eea 100%);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  pointer-events: none;
  z-index: 10000;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);
  max-width: 280px;
  white-space: normal;
  font-weight: 500;
}

.edit-form-data-btn::after {
  content: '';
  position: absolute;
  top: calc(100% + 6px);
  right: 20px;
  transform: none;
  border: 6px solid transparent;
  border-bottom-color: #3b82f6;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 10001;
}

.edit-form-data-btn:hover::before {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.edit-form-data-btn:hover::after {
  opacity: 1;
  visibility: visible;
  transform: none;
}

.tab-content {
  padding: 1.5rem 2rem;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modern Summary Content */
.modern-summary-content {
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: 100%;
}

/* In split view, remove extra styling since panel already has it */
.split-view .modern-summary-content {
  background: transparent;
  border: none;
  box-shadow: none;
  border-radius: 0;
  height: auto;
}

.summary-text-modern {
  padding: 0;
  line-height: 1.7;
  color: #374151;
  font-size: 0.9375rem;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
}

.summary-text-modern hr {
  border: none;
  border-top: 2px solid #e5e7eb;
  margin: 1.5rem 0;
}

/* Modern Form Data Display */
.form-data-modern {
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
}

.form-data-header-modern {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e7eb;
}

.form-data-header-modern h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

/* Form Data Grid Layout */
.form-data-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.25rem;
}

.form-data-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 1rem;
  transition: all 0.2s;
}

.form-data-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.form-data-label-modern {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
}

.form-data-value-modern {
  font-size: 0.9375rem;
  color: #1f2937;
  font-weight: 500;
  word-break: break-word;
}

.form-data-value-modern .empty-value {
  color: #9ca3af;
  font-style: italic;
}

.form-data-value-modern .structured-data-table {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.75rem;
  margin-top: 0.5rem;
}

/* Updated Regenerate Prompt */
.form-data-modern .regenerate-prompt {
  margin-top: 1.5rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #fbbf24;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.form-data-modern .regenerate-prompt svg {
  flex-shrink: 0;
  color: #d97706;
}

.form-data-modern .regenerate-prompt p {
  margin: 0 0 0.75rem 0;
  color: #92400e;
  font-weight: 600;
  font-size: 0.9375rem;
}

.form-data-modern .regenerate-prompt .regenerate-summary-btn {
  margin-top: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Stack panels vertically on mobile */
  .modern-modal-body.split-view {
    flex-direction: column;
    padding-top: 1rem;
  }

  .split-panel {
    min-height: auto;
    max-width: 100%; /* Full width on mobile */
    flex: 1 1 auto;
  }

  .split-panel .panel-content {
    max-height: 400px;
    min-height: 300px;
  }

  .left-panel {
    border-right: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .right-panel {
    border-radius: 0.75rem;
  }

  /* Mobile tooltip adjustments */
  .edit-form-data-btn::before {
    right: auto;
    left: 0;
    top: calc(100% + 12px);
    transform: translateY(10px);
    max-width: 240px;
    font-size: 0.75rem;
  }

  .edit-form-data-btn::after {
    right: auto;
    left: 20px;
    top: calc(100% + 6px);
    transform: none;
    border-left-color: transparent;
    border-bottom-color: #3b82f6;
  }

  .edit-form-data-btn:hover::before {
    transform: translateY(0);
  }

  .edit-form-data-btn:hover::after {
    transform: none;
  }

  .modern-summary-modal {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .modern-modal-header {
    padding: 1.5rem;
  }

  .header-title {
    font-size: 1.5rem;
  }

  .header-meta {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .action-bar {
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
  }

  .action-buttons-left {
    width: 100%;
  }

  .action-btn {
    flex: 1 1;
    justify-content: center;
  }

  .modern-tabs {
    padding: 0 1rem;
  }

  .tab-button {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .tab-content {
    padding: 1rem;
  }

  .form-data-modern {
    padding: 1rem;
  }

  .form-data-grid {
    grid-template-columns: 1fr;
  }

  .summary-text-modern {
    padding: 1.5rem;
    font-size: 0.9375rem;
  }
}

/* Summary Chat Section */
.summary-chat-section {
  margin-top: 20px;
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}

/* Summary Chat Styles */
.summary-chat {
  display: flex;
  flex-direction: column;
  height: 400px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease;
}

.summary-chat:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #3b82f6;
  color: white;
  border-bottom: 1px solid #e2e8f0;
}

.chat-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
}

.chat-close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.chat-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chat-welcome {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: #64748b;
}

.welcome-content {
  max-width: 300px;
}

.welcome-content h3 {
  margin: 12px 0 8px 0;
  color: #1e293b;
  font-size: 16px;
}

.welcome-content p {
  margin: 0 0 16px 0;
  font-size: 14px;
  line-height: 1.5;
}

.suggested-questions {
  text-align: left;
  background: white;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.suggested-questions p {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.suggested-questions ul {
  margin: 0;
  padding-left: 16px;
  font-size: 12px;
  color: #6b7280;
}

.suggested-questions li {
  margin-bottom: 4px;
}

.message {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.message.user {
  flex-direction: row-reverse;
}

.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message.user .message-avatar {
  background: #3b82f6;
  color: white;
}

.message.assistant .message-avatar {
  background: #10b981;
  color: white;
}

.message-content {
  max-width: 70%;
  background: white;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.message.user .message-content {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.message-text {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 4px;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 4px;
}

.chat-input-form {
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0 0 12px 12px;
}

.chat-input-container {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  position: relative;
}

.chat-input {
  flex: 1 1;
  min-height: 44px;
  max-height: 120px;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 500;
  resize: none;
  outline: none;
  transition: all 0.3s ease;
  font-family: inherit;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  color: #1e293b;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.chat-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
  font-style: italic;
}

.chat-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transform: translateY(-1px);
}

.chat-input:not(:placeholder-shown) {
  border-color: #10b981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);
}

.chat-input:hover:not(:focus) {
  border-color: #cbd5e1;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.chat-input:disabled {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #64748b;
  border-color: #e2e8f0;
  cursor: not-allowed;
}

.chat-send-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
  position: relative;
  overflow: hidden;
}

.chat-send-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.chat-send-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px) scale(1.05);
}

.chat-send-btn:hover:not(:disabled)::before {
  left: 100%;
}

.chat-send-btn:active:not(:disabled) {
  transform: translateY(0) scale(0.95);
}

.chat-send-btn:disabled {
  background: linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Animation for loading spinner */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Typing animation for input focus */
@keyframes inputPulse {
  0% {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  50% {
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }
  100% {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
}

.chat-input:focus {
  animation: inputPulse 2s ease-in-out infinite;
}

/* Smooth transitions for better UX */
.chat-input-container {
  transition: all 0.3s ease;
}

.chat-input-container:focus-within {
  transform: translateY(-2px);
}

/* Enhanced message animations */
.message {
  animation: slideInUp 0.3s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile responsive adjustments for chat */
@media (max-width: 768px) {
  .summary-chat {
    height: 350px;
  }
  
  .message-content {
    max-width: 85%;
  }
  
  .chat-messages {
    padding: 12px;
  }
  
  .chat-input-form {
    padding: 12px;
  }
}

/* =====================================================
   MOBILE MODAL FIXES
   ===================================================== */

/* Fix 1: Mobile Modal Overlay and Positioning */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
    align-items: flex-start;
    padding-top: 20px;
    overflow-y: auto;
  }
  
  .modern-summary-modal {
    width: 100% !important;
    max-width: 100% !important;
    max-height: calc(100vh - 40px) !important;
    margin: 0 !important;
    border-radius: 0.5rem;
    position: relative;
  }
  
  .summary-modal {
    width: 100% !important;
    max-width: 100% !important;
    max-height: calc(100vh - 40px) !important;
    margin: 0 !important;
  }
}

/* Fix 2: Improve Touch Targets for Mobile */
@media (max-width: 768px) {
  .view-btn, 
  .regenerate-btn,
  .action-buttons .view-btn,
  .action-buttons .regenerate-btn {
    min-height: 44px; /* iOS recommended touch target */
    padding: 12px 16px;
    font-size: 16px; /* Prevent zoom on iOS */
    border-radius: 8px;
  }
  
  .close-btn {
    min-height: 44px;
    min-width: 44px;
    font-size: 24px;
  }
}

/* Fix 3: Fix Modal Body Layout for Mobile */
@media (max-width: 768px) {
  .modern-modal-body.split-view {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem;
    overflow-y: auto;
  }
  
  .split-panel {
    min-height: 300px;
    max-height: 50vh;
    flex: 1 1 auto;
    width: 100%;
  }
  
  .left-panel {
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
    border-radius: 0.5rem 0.5rem 0 0;
  }
  
  .right-panel {
    border-radius: 0 0 0.5rem 0.5rem;
  }
}

/* Fix 4: Mobile Header Adjustments */
@media (max-width: 768px) {
  .modern-modal-header {
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
  }
  
  .header-title {
    font-size: 1.25rem;
    line-height: 1.4;
  }
  
  .header-meta {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    font-size: 0.875rem;
  }
  
  .header-actions {
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 1rem;
  }
}

/* Fix 5: Mobile Content Scrolling */
@media (max-width: 768px) {
  .modern-summary-content {
    max-height: none;
    overflow-y: visible;
  }
  
  .summary-text-modern {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .panel-content {
    max-height: none;
    overflow-y: visible;
  }
}

/* Fix 6: Mobile Table Responsiveness */
@media (max-width: 768px) {
  .summaries-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .summaries-table {
    min-width: 600px;
  }
  
  .summaries-table th,
  .summaries-table td {
    padding: 0.75rem 0.5rem;
    font-size: 14px;
  }
}

/* Fix 7: Mobile Form Layout */
@media (max-width: 768px) {
  .search-section {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }
  
  .search-input {
    font-size: 16px; /* Prevent zoom on iOS */
  }
  
  .filter-controls {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
}

/* Fix 8: Mobile Modal Full Screen Option */
@media (max-width: 480px) {
  .modal-overlay {
    padding: 0;
  }
  
  .modern-summary-modal {
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    border-radius: 0 !important;
  }
  
  .modern-modal-body {
    height: calc(100vh - 80px);
    overflow-y: auto;
  }
}

/* =====================================================
   FLOATING CHAT BUTTON & SIDE PANEL
   ===================================================== */

/* Floating Chat Button */
.floating-chat-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  animation: float 3s ease-in-out infinite;
}

.floating-chat-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
  background: linear-gradient(135deg, #4338ca 0%, #5b21b6 100%);
}

.floating-chat-btn:active {
  transform: translateY(0);
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
}

/* Chat Side Panel Overlay */
.chat-side-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
}

/* Chat Side Panel */
.chat-side-panel {
  width: 400px;
  height: 100vh;
  background: white;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  transform: translateX(0);
  transition: transform 0.3s ease;
  position: relative;
}

/* Chat Panel Header */
.chat-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  color: white;
  border-bottom: 1px solid #e5e7eb;
}

.chat-panel-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
}

.chat-panel-close {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-panel-close:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Chat Panel Content */
.chat-panel-content {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Override SummaryChat styles for side panel */
.chat-panel-content .summary-chat {
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.chat-panel-content .chat-header {
  display: none; /* Hide the original chat header since we have our own */
}

.chat-panel-content .chat-messages {
  flex: 1 1;
  height: calc(100vh - 160px); /* Adjust for header height + message limit indicator */
}

/* Message Limit Indicator Styles */
.message-limit-indicator {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.limit-reached {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #dc2626;
  font-size: 0.875rem;
  font-weight: 500;
}

.limit-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4f46e5;
  font-size: 0.875rem;
  font-weight: 500;
}

.limit-checking {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
}

.limit-icon {
  font-size: 1rem;
}

.limit-text {
  flex: 1 1;
}

/* Disabled input styles when limit reached */
.chat-input:disabled {
  background-color: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.chat-send-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

.chat-send-btn:disabled:hover {
  background-color: #d1d5db;
  transform: none;
  box-shadow: none;
}

/* Mobile Responsive for Chat Panel */
@media (max-width: 768px) {
  .floating-chat-btn {
    bottom: 80px; /* Above mobile navigation */
    right: 15px;
    width: 50px;
    height: 50px;
  }
  
  .chat-side-panel {
    width: 100vw;
    max-width: 100vw;
  }
  
  .chat-panel-header {
    padding: 1rem;
  }
  
  .chat-panel-title {
    font-size: 0.875rem;
  }
  
  .chat-panel-content .chat-messages {
    height: calc(100vh - 100px);
  }
}

@media (max-width: 480px) {
  .floating-chat-btn {
    bottom: 70px;
    right: 10px;
    width: 45px;
    height: 45px;
  }
  
  .floating-chat-btn svg {
    width: 20px;
    height: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConsultationSummaries.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,UAAU;EACV,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,yBAAyB;EAC3B;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,+DAA+D;EAC/D,aAAa;EAEb,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,4CAA4C;EAC5C,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,4CAA4C;EAC5C,8BAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+DAA+D;EAC/D,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mFAAmF;EACnF,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,YAAY,EAAE,4BAA4B;EAC1C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;EAGE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,+CAA+C;AAC/C;EACE,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,4CAA4C;AAC5C;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;6CAE6C;;AAE7C,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,iBAAiB,EAAE,4BAA4B;EAC/C,qFAAqF;EACrF,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,eAAe;EACf,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB,EAAE,sCAAsC;EAC3D,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,gCAAgC;EAC/C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,iBAAiB,EAAE,4BAA4B;EAC/C,YAAY,EAAE,qDAAqD;EACnE,cAAc,EAAE,mCAAmC;EACnD,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB,EAAE,iCAAiC;EACpD,iBAAiB,EAAE,mBAAmB;AACxC;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,sFAAsF;EACtF,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe,EAAE,yBAAyB;IAC1C,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,OAAO;IACP,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qCAAqC;AACrC;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;0DAE0D;;AAE1D,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,yCAAyC;IACzC,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,yCAAyC;IACzC,oBAAoB;EACtB;AACF;;AAEA,4CAA4C;AAC5C;EACE;;;;IAIE,gBAAgB,EAAE,iCAAiC;IACnD,kBAAkB;IAClB,eAAe,EAAE,wBAAwB;IACzC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;;0DAE0D;;AAE1D,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,6CAA6C;EAC7C,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,wDAAwD;AACzE;;AAEA;EACE,SAAO;EACP,2BAA2B,EAAE,uDAAuD;AACtF;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;IACE,YAAY,EAAE,4BAA4B;IAC1C,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Consultation Summaries Styles */\n.consultation-summaries {\n  padding: 0;\n  max-width: 100%;\n  margin: 0;\n  width: 100%;\n  background: white;\n}\n\n.consultation-summaries .header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 2rem 2rem 0 2rem;\n  background: white;\n}\n\n.consultation-summaries .header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 1rem 0;\n}\n\n.consultation-summaries .header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 0;\n  display: flex;\n  justify-content: center;\n  padding: 2rem 2rem 1.5rem 2rem;\n  background: white;\n}\n\n.search-inputs-row {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  color: #6b7280;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e5e7eb;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #6b7280;\n}\n\n.empty-state .empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.empty-state h3 {\n  margin: 0 0 0.5rem 0;\n  color: #374151;\n  font-size: 1.5rem;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Table Styles */\n.summaries-table-container {\n  background: white;\n  border-radius: 0;\n  box-shadow: none;\n  overflow: hidden;\n  border: none;\n  border-top: 1px solid #e5e7eb;\n  margin: 0;\n  padding: 0 2rem 2rem 2rem;\n}\n\n.summaries-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.summaries-table thead {\n  background-color: #f9fafb;\n}\n\n.summaries-table th {\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.summaries-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: middle;\n}\n\n.summaries-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n\n.summaries-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Table Cell Styles */\n.client-name {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.client-email {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.summary-status {\n  text-align: left;\n  vertical-align: middle;\n  padding-left: 2rem !important;\n}\n\n.summaries-table td.summary-status {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n/* Date Filters */\n.date-filters {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* Type Filter Dropdown */\n.type-filter-select {\n  padding: 0.75rem 1rem;\n  border: 2px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n  cursor: pointer;\n  background: white;\n  min-width: 160px;\n}\n\n.type-filter-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.date-input {\n  padding: 0.75rem 1rem;\n  border: 2px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  transition: border-color 0.2s;\n  cursor: pointer;\n}\n\n.date-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n/* Lead Type Badge Styles */\n.lead-type-cell {\n  width: 140px;\n}\n\n.lead-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  border: 1px solid;\n}\n\n.lead-type-badge .type-icon {\n  font-size: 14px;\n}\n\n.lead-type-badge .type-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.clear-date-btn {\n  padding: 0.75rem 1rem;\n  background-color: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.clear-date-btn:hover {\n  background-color: #dc2626;\n}\n\n/* Data Submitted Column */\n.data-submitted {\n  text-align: left;\n  vertical-align: middle;\n}\n\n.submitted-date {\n  color: #374151;\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.status-indicator-inline {\n  margin-top: 0.5rem;\n}\n\n/* Lead Quality Column */\n.lead-quality-cell {\n  text-align: left;\n  vertical-align: middle;\n}\n\n.lead-quality-badge-table {\n  display: inline-block;\n  padding: 0.375rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.lead-quality-badge-table.strong {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.lead-quality-badge-table.moderate {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.lead-quality-badge-table.weak {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.lead-quality-empty {\n  color: #9ca3af;\n  font-size: 0.875rem;\n  font-style: italic;\n}\n\n.status-badge-small {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  vertical-align: middle;\n}\n\n.status-badge-small.ready {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge-small.not-started {\n  background-color: #f3f4f6;\n  color: #6b7280;\n}\n\n.status-badge-small.processing {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.status-badge-small.failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Responsive Design for Date Filters */\n@media (min-width: 768px) {\n  .search-inputs-row {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .search-input {\n    flex: 1;\n    max-width: 400px;\n  }\n\n  .date-filters {\n    flex: 1;\n    justify-content: flex-end;\n  }\n}\n\n/* Latest Slider Container */\n.latest-slider-container {\n  background-color: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 1.25rem 2rem;\n  margin: 0 0 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.slider-controls-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 1;\n  min-width: 200px;\n}\n\n.sort-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.sort-controls label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.sort-select {\n  padding: 0.5rem 0.75rem;\n  border: 2px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  background: white;\n  color: #374151;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  min-width: 140px;\n}\n\n.sort-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.sort-order-btn {\n  padding: 0.5rem 0.75rem;\n  background: white;\n  border: 2px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 38px;\n}\n\n.sort-order-btn:hover {\n  border-color: #3b82f6;\n  background: #f0f9ff;\n  color: #3b82f6;\n}\n\n.sort-order-btn:active {\n  transform: scale(0.95);\n}\n\n.latest-slider-container label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  margin: 0;\n  white-space: nowrap;\n  min-width: fit-content;\n}\n\n.latest-slider-container input[type=\"range\"] {\n  flex: 0 0 auto;\n  width: 250px;\n  min-width: 200px;\n  max-width: 300px;\n  height: 6px;\n  border-radius: 3px;\n  background: linear-gradient(to right, #3b82f6 0%, #60a5fa 100%);\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.2);\n}\n\n.latest-slider-container input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #1e40af;\n  cursor: pointer;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.4);\n  transition: all 0.2s ease;\n}\n\n.latest-slider-container input[type=\"range\"]::-webkit-slider-thumb:hover {\n  background: #1e3a8a;\n  transform: scale(1.15);\n  box-shadow: 0 4px 8px rgba(30, 64, 175, 0.5);\n}\n\n.latest-slider-container input[type=\"range\"]::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #1e40af;\n  cursor: pointer;\n  border: 3px solid white;\n  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.4);\n  transition: all 0.2s ease;\n}\n\n.latest-slider-container input[type=\"range\"]::-moz-range-thumb:hover {\n  background: #1e3a8a;\n  transform: scale(1.15);\n  box-shadow: 0 4px 8px rgba(30, 64, 175, 0.5);\n}\n\n.latest-slider-container input[type=\"range\"]::-moz-range-track {\n  height: 6px;\n  border-radius: 3px;\n  background: linear-gradient(to right, #3b82f6 0%, #60a5fa 100%);\n  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.2);\n}\n\n.latest-slider-container input[type=\"range\"]:focus {\n  outline: none;\n}\n\n.latest-slider-container input[type=\"range\"]:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n.latest-slider-container input[type=\"range\"]:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n}\n\n/* Responsive adjustments for slider */\n@media (max-width: 640px) {\n  .latest-slider-container {\n    padding: 1rem;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .slider-controls-left {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .latest-slider-container label {\n    margin-bottom: 0.5rem;\n  }\n\n  .latest-slider-container input[type=\"range\"] {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  .sort-controls {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .sort-select {\n    flex: 1;\n    min-width: auto;\n  }\n}\n\n.actions {\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  vertical-align: middle;\n}\n\n.status-badge.ready {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.not-started {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.processing {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.status-badge.failed {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Real-time status indicator */\n.pulse-dot {\n  margin-left: 0.5rem;\n  color: #3b82f6;\n  animation: pulse 1.5s ease-in-out infinite;\n  font-size: 0.8rem;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(1.2);\n  }\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.view-btn {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  min-width: 70px;\n}\n\n.view-btn:hover {\n  background-color: #2563eb;\n}\n\n.generate-btn {\n  background-color: #10b981;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  min-width: 120px;\n}\n\n.generate-btn:hover:not(:disabled) {\n  background-color: #059669;\n}\n\n.generate-btn:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.regenerate-btn {\n  background-color: #f59e0b;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  min-width: 100px;\n}\n\n.regenerate-btn:hover:not(:disabled) {\n  background-color: #d97706;\n}\n\n.regenerate-btn:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.processing-text {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 0.875rem;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  overflow: visible; /* Allow tooltip to show outside modal */\n}\n\n.summary-modal {\n  background: white;\n  border-radius: 0.75rem;\n  max-width: 800px;\n  max-height: 90vh;\n  width: 90%;\n  overflow: hidden;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n  line-height: 1;\n  transition: color 0.2s;\n}\n\n.close-btn:hover {\n  color: #374151;\n}\n\n.modal-body {\n  padding: 2rem;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.client-info {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.client-info p {\n  margin: 0.25rem 0;\n  color: #475569;\n}\n\n.summary-content h3 {\n  margin: 0 0 1rem 0;\n  color: #1f2937;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.summary-text {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  line-height: 1.6;\n  color: #374151;\n  font-size: 1rem;\n  white-space: pre-wrap;\n  min-height: 200px;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .consultation-summaries {\n    padding: 1rem;\n  }\n  \n  .consultation-summaries .header h1 {\n    font-size: 2rem;\n  }\n  \n  .summaries-table-container {\n    overflow-x: auto;\n  }\n  \n  .summaries-table {\n    min-width: 600px;\n  }\n  \n  .summaries-table th,\n  .summaries-table td {\n    padding: 0.75rem 0.5rem;\n  }\n  \n  .summary-modal {\n    width: 95%;\n    margin: 1rem;\n  }\n  \n  .modal-header {\n    padding: 1rem 1.5rem;\n  }\n  \n  .modal-body {\n    padding: 1.5rem;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  \n  .action-buttons .view-btn,\n  .action-buttons .regenerate-btn {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n/* Toast Notification Styles */\n.toast-notification {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 10000;\n  min-width: 300px;\n  max-width: 500px;\n  border-radius: 0.75rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  animation: slideInRight 0.3s ease-out;\n}\n\n.toast-notification.success {\n  background-color: #d1fae5;\n  border: 1px solid #34d399;\n  color: #065f46;\n}\n\n.toast-notification.error {\n  background-color: #fef2f2;\n  border: 1px solid #f87171;\n  color: #991b1b;\n}\n\n.toast-content {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  gap: 0.75rem;\n}\n\n.toast-icon {\n  font-size: 1.25rem;\n  flex-shrink: 0;\n}\n\n.toast-message {\n  flex: 1;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.toast-close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  color: inherit;\n  cursor: pointer;\n  padding: 0.25rem;\n  line-height: 1;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  flex-shrink: 0;\n}\n\n.toast-close:hover {\n  opacity: 1;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Mobile responsive for toast */\n@media (max-width: 640px) {\n  .toast-notification {\n    top: 10px;\n    right: 10px;\n    left: 10px;\n    min-width: auto;\n    max-width: none;\n  }\n}\n\n/* Two-Column Modal Layout */\n.modal-content-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-top: 1rem;\n}\n\n.summary-content,\n.form-data-content {\n  min-width: 0; /* Allow content to shrink */\n  max-width: 100%;\n  overflow: visible;\n}\n\n.summary-content {\n  overflow: hidden;\n}\n\n.summary-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.summary-header h3,\n.summary-content h3,\n.form-data-content h3 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n/* Form Data Display */\n.form-data-display {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.form-data-item {\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.form-data-item:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.form-data-label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 0.25rem;\n}\n\n.form-data-value {\n  display: block;\n  font-size: 0.95rem;\n  color: #1e293b;\n  word-break: break-word;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Structured Data Display (for IELTS, Education, Work tables) */\n.structured-data-table {\n  background: white !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 0.375rem !important;\n  padding: 0.75rem !important;\n  margin-top: 0.25rem !important;\n  width: 100% !important;\n  border-collapse: collapse !important;\n  table-layout: auto !important;\n  display: table !important;\n  writing-mode: horizontal-tb !important;\n  direction: ltr !important;\n}\n\n.structured-data-table tbody {\n  width: 100% !important;\n  display: table-row-group !important;\n}\n\n.structured-data-row {\n  border-bottom: 1px solid #f1f5f9 !important;\n  display: table-row !important;\n  writing-mode: horizontal-tb !important;\n  direction: ltr !important;\n}\n\n.structured-data-row:last-child {\n  border-bottom: none !important;\n}\n\n/* Force all td elements to display inline text */\n.structured-data-table td {\n  display: table-cell !important;\n  writing-mode: horizontal-tb !important;\n  white-space: normal !important;\n}\n\n.structured-data-row .sub-label {\n  padding: 0.5rem 0.75rem 0.5rem 0 !important;\n  font-size: 0.8125rem !important;\n  font-weight: 600 !important;\n  color: #64748b !important;\n  text-align: right !important;\n  vertical-align: top !important;\n  white-space: nowrap !important;\n  width: 1% !important;\n  display: table-cell !important;\n  writing-mode: horizontal-tb !important;\n  direction: ltr !important;\n  flex-direction: row !important;\n}\n\n.structured-data-row .sub-value {\n  padding: 0.5rem 0 0.5rem 0.5rem !important;\n  font-size: 0.875rem !important;\n  color: #1e293b !important;\n  font-weight: 500 !important;\n  vertical-align: top !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n  width: auto !important;\n  max-width: none !important;\n  display: table-cell !important;\n  writing-mode: horizontal-tb !important;\n  direction: ltr !important;\n  flex-direction: row !important;\n}\n\n.simple-value {\n  display: inline !important;\n  font-size: 0.95rem;\n  color: #1e293b;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal !important;\n  writing-mode: horizontal-tb !important;\n}\n\n.empty-value {\n  display: inline !important;\n  font-size: 0.95rem;\n  color: #94a3b8;\n  font-style: italic;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal !important;\n  writing-mode: horizontal-tb !important;\n}\n\n/* Adjust summary modal width for two columns */\n.summary-modal {\n  max-width: 1400px !important;\n}\n\n/* Force horizontal text display in modal */\n.summary-modal .structured-data-table {\n  display: table !important;\n  width: 100% !important;\n}\n\n.summary-modal .structured-data-table tbody {\n  display: table-row-group !important;\n}\n\n.summary-modal .structured-data-row {\n  display: table-row !important;\n}\n\n.summary-modal .structured-data-row td {\n  display: table-cell !important;\n  white-space: normal !important;\n  writing-mode: horizontal-tb !important;\n}\n\n/* Mobile responsive for two-column layout */\n@media (max-width: 1024px) {\n  .modal-content-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .summary-modal {\n    max-width: 90% !important;\n  }\n}\n\n/* Form Data Edit Mode */\n.form-data-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  position: relative;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.form-data-header h3 {\n  margin: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.form-data-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-form-data-btn,\n.save-form-data-btn,\n.cancel-edit-btn {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.edit-form-data-btn {\n  background: #3b82f6;\n  color: white;\n}\n\n.edit-form-data-btn:hover {\n  background: #2563eb;\n}\n\n.save-form-data-btn {\n  background: #10b981;\n  color: white;\n}\n\n.save-form-data-btn:hover {\n  background: #059669;\n}\n\n.save-form-data-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n.cancel-edit-btn {\n  background: #ef4444;\n  color: white;\n}\n\n.cancel-edit-btn:hover {\n  background: #dc2626;\n}\n\n.form-data-input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 2px solid #3b82f6;\n  border-radius: 0.375rem;\n  font-size: 0.95rem;\n  color: #1e293b;\n  background: white;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.form-data-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Structured Data Edit Mode */\n.structured-data-edit {\n  background: white;\n  border: 2px solid #3b82f6;\n  border-radius: 0.375rem;\n  padding: 0.75rem;\n  margin-top: 0.25rem;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.structured-data-edit-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.structured-data-edit-row:last-child {\n  margin-bottom: 0;\n}\n\n.sub-label-edit {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #475569;\n  text-align: left;\n}\n\n.sub-field-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  color: #1e293b;\n  background: white;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.sub-field-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n}\n\n.sub-field-input::placeholder {\n  color: #94a3b8;\n  font-size: 0.8125rem;\n}\n\n/* Regenerate Prompt */\n.regenerate-prompt {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: #fef3c7;\n  border: 2px solid #fbbf24;\n  border-radius: 0.5rem;\n  text-align: center;\n}\n\n.regenerate-prompt p {\n  margin: 0 0 0.75rem 0;\n  color: #92400e;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.regenerate-summary-btn {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.regenerate-summary-btn:hover {\n  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.regenerate-summary-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Custom Tooltip */\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.custom-tooltip {\n  position: absolute;\n  top: 50%;\n  right: calc(100% + 12px);\n  transform: translateY(-50%);\n  background: #1f2937;\n  color: #ffffff;\n  padding: 1rem 1.25rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);\n  z-index: 100000;\n  width: 320px;\n  pointer-events: none;\n  white-space: normal;\n  opacity: 1;\n  display: block;\n}\n\n.custom-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  transform: translateY(-50%);\n  border: 10px solid transparent;\n  border-left-color: #1f2937;\n}\n\n.custom-tooltip p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #ffffff;\n  text-align: left;\n  display: block;\n}\n\n.custom-tooltip p:first-child {\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  color: #ffffff;\n}\n\n.custom-tooltip p:last-child {\n  color: #e5e7eb;\n  font-weight: 400;\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Regenerate Button in Modal */\n.regenerate-in-modal-btn {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n}\n\n.regenerate-in-modal-btn:hover {\n  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);\n}\n\n.regenerate-in-modal-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Summary Loading State */\n.summary-loading {\n  background-color: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 3rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n}\n\n.summary-loading .loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e5e7eb;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1.5rem;\n}\n\n.summary-loading p {\n  margin: 0;\n  color: #374151;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.summary-loading .loading-subtext {\n  margin-top: 0.5rem;\n  color: #6b7280;\n  font-size: 0.95rem;\n  font-weight: 400;\n}\n\n/* ========================================\n   MODERN CONSULTATION SUMMARY MODAL\n   ======================================== */\n\n/* Modern Modal Container */\n.modern-summary-modal {\n  background: white;\n  border-radius: 0.75rem;\n  max-width: 1400px;\n  max-height: 95vh;\n  width: 98%;\n  overflow: visible; /* Allow tooltip to escape */\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Modern Header - Blue Background */\n.modern-modal-header {\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  color: white;\n  padding: 1.25rem 2rem;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.header-left {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.header-icon {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.75rem;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.header-subtitle {\n  font-size: 0.875rem;\n  color: rgba(255, 255, 255, 0.95);\n  margin-bottom: 0.25rem;\n  font-weight: 500;\n}\n\n.header-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0.25rem 0;\n  color: white !important;\n}\n\n.header-description {\n  font-size: 0.9375rem;\n  color: rgba(255, 255, 255, 0.95) !important;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.modern-close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 2rem;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  backdrop-filter: blur(10px);\n  line-height: 1;\n  padding: 0;\n}\n\n.modern-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n/* Header Meta Information */\n.header-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.25rem;\n}\n\n.meta-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.meta-label {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n}\n\n.meta-value {\n  font-size: 1rem;\n  color: white !important;\n  font-weight: 600;\n}\n\n/* Lead Quality Badge in Header */\n.lead-quality-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.lead-quality-badge.strong {\n  background: rgba(16, 185, 129, 0.3);\n  border-color: rgba(16, 185, 129, 0.5);\n  color: #d1fae5;\n}\n\n.lead-quality-badge.moderate {\n  background: rgba(245, 158, 11, 0.3);\n  border-color: rgba(245, 158, 11, 0.5);\n  color: #fef3c7;\n}\n\n.lead-quality-badge.weak {\n  background: rgba(239, 68, 68, 0.3);\n  border-color: rgba(239, 68, 68, 0.5);\n  color: #fee2e2;\n}\n\n/* Lead Score Value */\n.lead-score-value {\n  font-size: 1.125rem !important;\n  font-weight: 700 !important;\n  color: #fbbf24 !important;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n/* Action Bar */\n.action-bar {\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  padding: 0.75rem 2rem;\n  border-bottom: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  min-height: 56px;\n}\n\n.action-buttons-left {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n  white-space: nowrap;\n  min-width: fit-content;\n  overflow: hidden;\n}\n\n.action-btn.primary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.action-btn.primary:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.action-btn.secondary {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.action-btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.action-btn.regenerate {\n  background: rgba(255, 255, 255, 0.95);\n  color: #4f46e5;\n  font-weight: 700;\n}\n\n.action-btn.regenerate:hover:not(:disabled) {\n  background: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.action-btn.regenerate:disabled {\n  background: rgba(255, 255, 255, 0.5);\n  color: rgba(79, 70, 229, 0.5);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Modern Tabs */\n.modern-tabs {\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  padding: 0 2rem;\n  display: flex;\n  gap: 0.5rem;\n  border-bottom: none;\n}\n\n.tab-button {\n  padding: 0.875rem 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  border-radius: 0.5rem 0.5rem 0 0;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  margin-bottom: 0;\n}\n\n.tab-button:hover {\n  color: white;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.tab-button.active {\n  color: #1f2937;\n  background: white;\n  font-weight: 700;\n}\n\n/* Modern Modal Body */\n.modern-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible; /* Allow horizontal tooltip overflow */\n  background: #f9fafb;\n}\n\n/* Split View Layout */\n.modern-modal-body.split-view {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n}\n\n.split-panel {\n  flex: 1 1 50%; /* Equal width for both panels */\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 0.75rem;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: visible; /* Allow tooltip to escape */\n  min-width: 0; /* Allow panels to shrink below their content width */\n  max-width: 50%; /* Ensure panels stay equal width */\n  height: fit-content;\n}\n\n/* Visual divider between panels */\n.left-panel {\n  border-right: 2px solid #e5e7eb;\n  border-radius: 0.75rem 0 0 0.75rem;\n}\n\n.right-panel {\n  border-radius: 0 0.75rem 0.75rem 0;\n}\n\n.split-panel .panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.875rem 1.25rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-bottom: 1px solid #e5e7eb;\n  min-height: 56px;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 100;\n  overflow: visible;\n}\n\n.split-panel .panel-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.025em;\n}\n\n.split-panel .panel-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1.5rem;\n  background: #ffffff;\n  position: relative;\n  max-height: 600px; /* Set max height for scrolling */\n  min-height: 400px; /* Minimum height */\n}\n\n/* Custom scrollbar styling */\n.split-panel .panel-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.split-panel .panel-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.split-panel .panel-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.split-panel .panel-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Always show scrollbar */\n.split-panel .panel-content {\n  scrollbar-gutter: stable;\n}\n\n/* Make both panels have same background */\n.left-panel .panel-content {\n  background: #ffffff;\n}\n\n.right-panel .panel-content {\n  background: #ffffff;\n}\n\n/* Edit Data Button Tooltip */\n.form-data-actions {\n  position: relative;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.edit-form-data-btn,\n.save-form-data-btn,\n.cancel-edit-btn {\n  position: relative;\n}\n\n.edit-form-data-btn::before {\n  content: '💡 Click to edit source data, then regenerate summary to update AI analysis';\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  transform: translateY(10px);\n  background: linear-gradient(135deg, #3b82f6 0%, #667eea 100%);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  pointer-events: none;\n  z-index: 10000;\n  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.3);\n  max-width: 280px;\n  white-space: normal;\n  font-weight: 500;\n}\n\n.edit-form-data-btn::after {\n  content: '';\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 20px;\n  transform: none;\n  border: 6px solid transparent;\n  border-bottom-color: #3b82f6;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  z-index: 10001;\n}\n\n.edit-form-data-btn:hover::before {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.edit-form-data-btn:hover::after {\n  opacity: 1;\n  visibility: visible;\n  transform: none;\n}\n\n.tab-content {\n  padding: 1.5rem 2rem;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Modern Summary Content */\n.modern-summary-content {\n  background: white;\n  border-radius: 0.75rem;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  height: 100%;\n}\n\n/* In split view, remove extra styling since panel already has it */\n.split-view .modern-summary-content {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  height: auto;\n}\n\n.summary-text-modern {\n  padding: 0;\n  line-height: 1.7;\n  color: #374151;\n  font-size: 0.9375rem;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.summary-text-modern hr {\n  border: none;\n  border-top: 2px solid #e5e7eb;\n  margin: 1.5rem 0;\n}\n\n/* Modern Form Data Display */\n.form-data-modern {\n  background: white;\n  border-radius: 0.75rem;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n}\n\n.form-data-header-modern {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.form-data-header-modern h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n/* Form Data Grid Layout */\n.form-data-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.25rem;\n}\n\n.form-data-card {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  transition: all 0.2s;\n}\n\n.form-data-card:hover {\n  border-color: #d1d5db;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.form-data-label-modern {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.5rem;\n}\n\n.form-data-value-modern {\n  font-size: 0.9375rem;\n  color: #1f2937;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.form-data-value-modern .empty-value {\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.form-data-value-modern .structured-data-table {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  padding: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n/* Updated Regenerate Prompt */\n.form-data-modern .regenerate-prompt {\n  margin-top: 1.5rem;\n  padding: 1.25rem;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 2px solid #fbbf24;\n  border-radius: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.form-data-modern .regenerate-prompt svg {\n  flex-shrink: 0;\n  color: #d97706;\n}\n\n.form-data-modern .regenerate-prompt p {\n  margin: 0 0 0.75rem 0;\n  color: #92400e;\n  font-weight: 600;\n  font-size: 0.9375rem;\n}\n\n.form-data-modern .regenerate-prompt .regenerate-summary-btn {\n  margin-top: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  /* Stack panels vertically on mobile */\n  .modern-modal-body.split-view {\n    flex-direction: column;\n    padding-top: 1rem;\n  }\n\n  .split-panel {\n    min-height: auto;\n    max-width: 100%; /* Full width on mobile */\n    flex: 1 1 auto;\n  }\n\n  .split-panel .panel-content {\n    max-height: 400px;\n    min-height: 300px;\n  }\n\n  .left-panel {\n    border-right: 1px solid #e5e7eb;\n    border-radius: 0.75rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .right-panel {\n    border-radius: 0.75rem;\n  }\n\n  /* Mobile tooltip adjustments */\n  .edit-form-data-btn::before {\n    right: auto;\n    left: 0;\n    top: calc(100% + 12px);\n    transform: translateY(10px);\n    max-width: 240px;\n    font-size: 0.75rem;\n  }\n\n  .edit-form-data-btn::after {\n    right: auto;\n    left: 20px;\n    top: calc(100% + 6px);\n    transform: none;\n    border-left-color: transparent;\n    border-bottom-color: #3b82f6;\n  }\n\n  .edit-form-data-btn:hover::before {\n    transform: translateY(0);\n  }\n\n  .edit-form-data-btn:hover::after {\n    transform: none;\n  }\n\n  .modern-summary-modal {\n    width: 100%;\n    max-width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .modern-modal-header {\n    padding: 1.5rem;\n  }\n\n  .header-title {\n    font-size: 1.5rem;\n  }\n\n  .header-meta {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .action-bar {\n    padding: 1rem;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .action-buttons-left {\n    width: 100%;\n  }\n\n  .action-btn {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .modern-tabs {\n    padding: 0 1rem;\n  }\n\n  .tab-button {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n\n  .tab-content {\n    padding: 1rem;\n  }\n\n  .form-data-modern {\n    padding: 1rem;\n  }\n\n  .form-data-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-text-modern {\n    padding: 1.5rem;\n    font-size: 0.9375rem;\n  }\n}\n\n/* Summary Chat Section */\n.summary-chat-section {\n  margin-top: 20px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}\n\n/* Summary Chat Styles */\n.summary-chat {\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: box-shadow 0.3s ease;\n}\n\n.summary-chat:hover {\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #3b82f6;\n  color: white;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.chat-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.chat-close-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.chat-close-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.chat-welcome {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  color: #64748b;\n}\n\n.welcome-content {\n  max-width: 300px;\n}\n\n.welcome-content h3 {\n  margin: 12px 0 8px 0;\n  color: #1e293b;\n  font-size: 16px;\n}\n\n.welcome-content p {\n  margin: 0 0 16px 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.suggested-questions {\n  text-align: left;\n  background: white;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.suggested-questions p {\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.suggested-questions ul {\n  margin: 0;\n  padding-left: 16px;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.suggested-questions li {\n  margin-bottom: 4px;\n}\n\n.message {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.message.user {\n  flex-direction: row-reverse;\n}\n\n.message-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.message.user .message-avatar {\n  background: #3b82f6;\n  color: white;\n}\n\n.message.assistant .message-avatar {\n  background: #10b981;\n  color: white;\n}\n\n.message-content {\n  max-width: 70%;\n  background: white;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.message.user .message-content {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.message-text {\n  font-size: 14px;\n  line-height: 1.5;\n  margin-bottom: 4px;\n}\n\n.message-time {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n.chat-input-form {\n  padding: 20px;\n  border-top: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 0 0 12px 12px;\n}\n\n.chat-input-container {\n  display: flex;\n  gap: 12px;\n  align-items: flex-end;\n  position: relative;\n}\n\n.chat-input {\n  flex: 1;\n  min-height: 44px;\n  max-height: 120px;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 24px;\n  font-size: 15px;\n  font-weight: 500;\n  resize: none;\n  outline: none;\n  transition: all 0.3s ease;\n  font-family: inherit;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  color: #1e293b;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.chat-input::placeholder {\n  color: #94a3b8;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.chat-input:focus {\n  border-color: #3b82f6;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n  transform: translateY(-1px);\n}\n\n.chat-input:not(:placeholder-shown) {\n  border-color: #10b981;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);\n}\n\n.chat-input:hover:not(:focus) {\n  border-color: #cbd5e1;\n  background: #ffffff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.chat-input:disabled {\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  color: #64748b;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n}\n\n.chat-send-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.chat-send-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.chat-send-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);\n  transform: translateY(-1px) scale(1.05);\n}\n\n.chat-send-btn:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.chat-send-btn:active:not(:disabled) {\n  transform: translateY(0) scale(0.95);\n}\n\n.chat-send-btn:disabled {\n  background: linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Animation for loading spinner */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Typing animation for input focus */\n@keyframes inputPulse {\n  0% {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n  50% {\n    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n  }\n  100% {\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.chat-input:focus {\n  animation: inputPulse 2s ease-in-out infinite;\n}\n\n/* Smooth transitions for better UX */\n.chat-input-container {\n  transition: all 0.3s ease;\n}\n\n.chat-input-container:focus-within {\n  transform: translateY(-2px);\n}\n\n/* Enhanced message animations */\n.message {\n  animation: slideInUp 0.3s ease-out;\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile responsive adjustments for chat */\n@media (max-width: 768px) {\n  .summary-chat {\n    height: 350px;\n  }\n  \n  .message-content {\n    max-width: 85%;\n  }\n  \n  .chat-messages {\n    padding: 12px;\n  }\n  \n  .chat-input-form {\n    padding: 12px;\n  }\n}\n\n/* =====================================================\n   MOBILE MODAL FIXES\n   ===================================================== */\n\n/* Fix 1: Mobile Modal Overlay and Positioning */\n@media (max-width: 768px) {\n  .modal-overlay {\n    padding: 10px;\n    align-items: flex-start;\n    padding-top: 20px;\n    overflow-y: auto;\n  }\n  \n  .modern-summary-modal {\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: calc(100vh - 40px) !important;\n    margin: 0 !important;\n    border-radius: 0.5rem;\n    position: relative;\n  }\n  \n  .summary-modal {\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: calc(100vh - 40px) !important;\n    margin: 0 !important;\n  }\n}\n\n/* Fix 2: Improve Touch Targets for Mobile */\n@media (max-width: 768px) {\n  .view-btn, \n  .regenerate-btn,\n  .action-buttons .view-btn,\n  .action-buttons .regenerate-btn {\n    min-height: 44px; /* iOS recommended touch target */\n    padding: 12px 16px;\n    font-size: 16px; /* Prevent zoom on iOS */\n    border-radius: 8px;\n  }\n  \n  .close-btn {\n    min-height: 44px;\n    min-width: 44px;\n    font-size: 24px;\n  }\n}\n\n/* Fix 3: Fix Modal Body Layout for Mobile */\n@media (max-width: 768px) {\n  .modern-modal-body.split-view {\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0.5rem;\n    overflow-y: auto;\n  }\n  \n  .split-panel {\n    min-height: 300px;\n    max-height: 50vh;\n    flex: 1 1 auto;\n    width: 100%;\n  }\n  \n  .left-panel {\n    border-right: none;\n    border-bottom: 1px solid #e5e7eb;\n    border-radius: 0.5rem 0.5rem 0 0;\n  }\n  \n  .right-panel {\n    border-radius: 0 0 0.5rem 0.5rem;\n  }\n}\n\n/* Fix 4: Mobile Header Adjustments */\n@media (max-width: 768px) {\n  .modern-modal-header {\n    padding: 1rem;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n  }\n  \n  .header-title {\n    font-size: 1.25rem;\n    line-height: 1.4;\n  }\n  \n  .header-meta {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n  }\n  \n  .header-actions {\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-top: 1rem;\n  }\n}\n\n/* Fix 5: Mobile Content Scrolling */\n@media (max-width: 768px) {\n  .modern-summary-content {\n    max-height: none;\n    overflow-y: visible;\n  }\n  \n  .summary-text-modern {\n    font-size: 14px;\n    line-height: 1.6;\n  }\n  \n  .panel-content {\n    max-height: none;\n    overflow-y: visible;\n  }\n}\n\n/* Fix 6: Mobile Table Responsiveness */\n@media (max-width: 768px) {\n  .summaries-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .summaries-table {\n    min-width: 600px;\n  }\n  \n  .summaries-table th,\n  .summaries-table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 14px;\n  }\n}\n\n/* Fix 7: Mobile Form Layout */\n@media (max-width: 768px) {\n  .search-section {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n  \n  .search-input {\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n  \n  .filter-controls {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n  }\n}\n\n/* Fix 8: Mobile Modal Full Screen Option */\n@media (max-width: 480px) {\n  .modal-overlay {\n    padding: 0;\n  }\n  \n  .modern-summary-modal {\n    width: 100vw !important;\n    height: 100vh !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n    border-radius: 0 !important;\n  }\n  \n  .modern-modal-body {\n    height: calc(100vh - 80px);\n    overflow-y: auto;\n  }\n}\n\n/* =====================================================\n   FLOATING CHAT BUTTON & SIDE PANEL\n   ===================================================== */\n\n/* Floating Chat Button */\n.floating-chat-btn {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  color: white;\n  border: none;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  cursor: pointer;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  animation: float 3s ease-in-out infinite;\n}\n\n.floating-chat-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n  background: linear-gradient(135deg, #4338ca 0%, #5b21b6 100%);\n}\n\n.floating-chat-btn:active {\n  transform: translateY(0);\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n}\n\n/* Chat Side Panel Overlay */\n.chat-side-panel-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1001;\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n}\n\n/* Chat Side Panel */\n.chat-side-panel {\n  width: 400px;\n  height: 100vh;\n  background: white;\n  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  transform: translateX(0);\n  transition: transform 0.3s ease;\n  position: relative;\n}\n\n/* Chat Panel Header */\n.chat-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  color: white;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.chat-panel-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.chat-panel-close {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chat-panel-close:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Chat Panel Content */\n.chat-panel-content {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Override SummaryChat styles for side panel */\n.chat-panel-content .summary-chat {\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.chat-panel-content .chat-header {\n  display: none; /* Hide the original chat header since we have our own */\n}\n\n.chat-panel-content .chat-messages {\n  flex: 1;\n  height: calc(100vh - 160px); /* Adjust for header height + message limit indicator */\n}\n\n/* Message Limit Indicator Styles */\n.message-limit-indicator {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.limit-reached {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #dc2626;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.limit-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #4f46e5;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.limit-checking {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.limit-icon {\n  font-size: 1rem;\n}\n\n.limit-text {\n  flex: 1;\n}\n\n/* Disabled input styles when limit reached */\n.chat-input:disabled {\n  background-color: #f3f4f6;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.chat-send-btn:disabled {\n  background-color: #d1d5db;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.chat-send-btn:disabled:hover {\n  background-color: #d1d5db;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Mobile Responsive for Chat Panel */\n@media (max-width: 768px) {\n  .floating-chat-btn {\n    bottom: 80px; /* Above mobile navigation */\n    right: 15px;\n    width: 50px;\n    height: 50px;\n  }\n  \n  .chat-side-panel {\n    width: 100vw;\n    max-width: 100vw;\n  }\n  \n  .chat-panel-header {\n    padding: 1rem;\n  }\n  \n  .chat-panel-title {\n    font-size: 0.875rem;\n  }\n  \n  .chat-panel-content .chat-messages {\n    height: calc(100vh - 100px);\n  }\n}\n\n@media (max-width: 480px) {\n  .floating-chat-btn {\n    bottom: 70px;\n    right: 10px;\n    width: 45px;\n    height: 45px;\n  }\n  \n  .floating-chat-btn svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
